import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`When using a screenshot it’s best to match the background. Take a screenshot on a similar color background or use a PNG with a transparent background as this will look the most seamless.`}</p>
    <h2>{`Usage guidelines`}</h2>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="example of using an image with a white background on top of a slide with a white background" src="https://user-images.githubusercontent.com/10384315/54647439-b32e1100-4a5f-11e9-8d85-a4a2e64319ca.png" />
    <Caption mdxType="Caption">Use images with a similar or transparent background</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="example of using an image with a white background on top of a slide with a black background" src="https://user-images.githubusercontent.com/10384315/54647548-1f107980-4a60-11e9-9640-8f1721609e44.png" />
    <Caption mdxType="Caption">Don't use images with opposite backgrounds to the slide background</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`📍Tip: Seamless image backgrounds`}</h3>
    <p>{`If you need to use a specific image but the slide background doesn't match, you can change the background color to match the image's background color.`}</p>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/56434794-05469a00-628b-11e9-8447-93bb44facbec.gif",
        "alt": "animated gif showing the background color of the slide being color picked from the background color in the image"
      }}></img></p>
    <h2>{`Adding images`}</h2>
    <p>{`Images can be added to any presentation by dragging and dropping, copy and pasting, or inserting from the toolbar in Keynote, Google Slides, and Figma.`}</p>
    <h3>{`Adding images in Keynote`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Source`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Browser`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Drag and drop any image from the web browser into Keynote`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55426909-c4385100-553a-11e9-88b6-467a4134f1cf.gif",
              "alt": "animated gif example of dragging and dropping an image from a web browser into keynote"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Local machine`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Drag and drop any image from the Finder into Keynote`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55426910-c4385100-553a-11e9-811a-69ecc5710708.gif",
              "alt": "animated gif example of dragging and dropping an image from a the Finder in macOS into keynote"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3>{`Replacing images in Keynote`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Step`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Select the image and click the `}<strong parentName="td">{`Image`}</strong>{` tab`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55841326-9ecfb800-5ae3-11e9-918a-fc5e9ecfb94b.gif",
              "alt": "The keynote inspector on the right side of the window with the mouse clicking on the middle Image button"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Click the `}<strong parentName="td">{`Replace`}</strong></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55432266-4d558500-5547-11e9-88b2-21818e9182c3.png",
              "alt": "The keynote inspector on the right side of the window with the Replace button available"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Select the new image and click `}<strong parentName="td">{`Open`}</strong></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55841327-9ecfb800-5ae3-11e9-8277-2c0aa79a0f3a.gif",
              "alt": "Selecting an image from the finder and inserting by clicking Open"
            }}></img></td>
        </tr>
      </tbody>
    </table>
    <h3>{`Adding images in Google Slides`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Source`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Browser`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Drag and drop any image from any tab in your web browser into the tab with Google Slides`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55434040-7d9f2280-554b-11e9-926c-690b8a001c3e.gif",
              "alt": "Example showing an image from one tab in the web browser being moved to the tab opened to the presentation in Google Slides"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Local machine`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`In the toolbar select `}<inlineCode parentName="td">{`Insert > Image > Upload from computer`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55434041-7d9f2280-554b-11e9-844f-8d019a7d8466.gif",
              "alt": "Google Slides toolbar above the slide with Insert Image displayed"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`By URL`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`In the toolbar select `}<inlineCode parentName="td">{`Insert > Image > By URL`}</inlineCode>{` and paste the image's URL`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55434043-7d9f2280-554b-11e9-9c2b-520055cbbfb5.gif",
              "alt": "Mouse moves to menu time By URL in the Google Slides toolbar"
            }}></img></td>
        </tr>
      </tbody>
    </table>
    <h3>{`Replacing images in Google Slides`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Step`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`With the image selected, click `}<strong parentName="td">{`Replace Image`}</strong>{` in the toolbar`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55434339-3feec980-554c-11e9-87aa-607f84827120.png",
              "alt": "Click Replace Image in toolbar, second from the right"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Select which method to replace your image`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img width="500" alt="Replace images by uploading from computer, searching on the web, add from Google Drive, Google Photos, by URL, or from the camera on your device" src="https://user-images.githubusercontent.com/10384315/54858092-f686ba80-4cbf-11e9-821d-dfc9febc02e8.png" /></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      